import { mapActions } from 'vuex';
import { TASKS_PARTNER_FILTER_EVENTS } from '../config';

export default {
  created() {
    const unwatch = this.$store.watch(
      (_, getters) => getters['currentUserModule/getCurrentUserId'],
      (newVal) => {
        if (newVal) {
          this.partnerFilterOptions.splice(1, 0, {
            id: newVal,
            name: 'Мої завдання',
            event: TASKS_PARTNER_FILTER_EVENTS.TASKS_PARTNER_FILTER_MAIN,
            options: {
              type: 'checkbox',
              multiselect: false,
            }
          });

          this.$eventBus.$on(
            TASKS_PARTNER_FILTER_EVENTS.TASKS_PARTNER_FILTER_MAIN,
            (item) => { this.setSelectedFilter('partner', item.id); }
          );

          this.setupFilter({
            filters: { partner: newVal, period: { start: new Date(), end: new Date() } },
            mode: 'replace',
            refetchData: true,
          });

          unwatch();
        }
      }
    );
  },
  beforeDestroy() {
    this.$eventBus.$off(
      TASKS_PARTNER_FILTER_EVENTS.TASKS_PARTNER_FILTER_MAIN,
      (item) => { this.setSelectedFilter('partner', item.id); }
    );
  },
  actions: {
    ...mapActions('activeTasksModule', ['setupFilter']),
  },
};
